import React, { useState } from 'react';
import moment from 'moment';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
// import jsPDF from 'jspdf'; 
import '../styles/EventModal.css';
import FormatUrl from '../../../utils/UrlFormatter'
import { notifySuccess, notifyError } from '../../../utils/toastNotifications';


const EventModal = ({user, event, onSave, onDelete, onClose, availableTimeSlots, isFirstTimeEditing, clinicPatientId, amount }) => {
  const { t } = useTranslation();

  // const savedDetails = (() => {
  //   try {
  //     return JSON.parse(localStorage.getItem('patientBookingDetails')) || {};
  //   } catch (error) {
  //     console.error("Error parsing localStorage data:", error);
  //     return {}; 
  //   }
  // })();

  
  // const clinicId = process.env.REACT_APP_CLINIC_ID && process.env.REACT_APP_CLINIC_ID !== "0"
  //   ? process.env.REACT_APP_CLINIC_ID
  //   : savedDetails?.selectedClinic?.clinic_id || null;

  
  // const patientId = savedDetails?.patientId || null;

//   useEffect(() => {
//     if (clinicId && patientId) {
//         console.log('Retrieved clinic_id:', clinicId, 'Retrieved patient_id:', patientId);
//     } else {
//         console.warn('Missing clinic_id or patient_id in saved details. This may be expected before selection.');
//     }
// }, [clinicId, patientId]); 

  const [subject, setSubject] = useState(event.subject || '');
  
  const [startTime, setStartTime] = useState(moment(event.start).format('YYYY-MM-DDTHH:mm')); 
  const [endTime, setEndTime] = useState(moment(event.end).format('YYYY-MM-DDTHH:mm')); 
  // const [medicalHistory, setMedicalHistory] = useState(event.intakeForm?.medicalHistory || '');
  // const [currentMedications, setCurrentMedications] = useState(event.intakeForm?.currentMedications || '');
  // const [allergies, setAllergies] = useState(event.intakeForm?.allergies || '');
  const [subjectError, setSubjectError] = useState('');
  const [timeError, setTimeError] = useState('');
  const [loading, setLoading] = useState(false);


  const minimumSlotDuration = 15 * 60 * 1000; 

  const isTimeWithinSlot = (time) => {
    return availableTimeSlots.some(slot => {
      const slotStart = moment(slot.start).format('YYYY-MM-DDTHH:mm');
      const slotEnd = moment(slot.end).format('YYYY-MM-DDTHH:mm');
      return time >= slotStart && time <= slotEnd;
    });
  };
  
  const validateForm = () => {
  
    // Validate subject
    if (!subject.trim()) {
      setSubjectError('Subject is required.');
      return false;
    }

    // Clear errors if validations pass
    setSubjectError('');
    // setCardError('');
    return true;
  };
  
  const handleSave = async () => {
    setLoading(true);
    
    if (!validateForm()) {
      setLoading(false); 
      return;
    }

    // Safe retrieval of saved details
    const savedDetails = (() => {
      try {
        return JSON.parse(localStorage.getItem('patientBookingDetails')) || {};
      } catch (error) {
        console.error("Error parsing localStorage:", error);
        return {};
      }
    })();

    // Use ENV clinic ID if set, otherwise fallback to localStorage
    const clinicId = process.env.REACT_APP_CLINIC_ID && process.env.REACT_APP_CLINIC_ID !== "0"
        ? process.env.REACT_APP_CLINIC_ID
        : savedDetails.selectedClinic?.clinic_id || null;

    const patientId = savedDetails.patientId || null;
    const slotId = event.id;

    if (!clinicId || !patientId || !slotId) {
        console.error('Missing required parameters: clinic_id, patient_id, or slot_id.');
        notifyError(t("event_modal.error_missing_parameters"));
        setLoading(false);
        return;
    }

    const startTimeObj = new Date(startTime);
    const endTimeObj = new Date(endTime);
    const slotDuration = endTimeObj.getTime() - startTimeObj.getTime();

    // Validation Checks**
    if (!subject.trim()) {
        setSubjectError('Subject is required.');
        setLoading(false);
        return;
    }

    if (!isTimeWithinSlot(startTime) || !isTimeWithinSlot(endTime)) {
        setTimeError('Start or End time is out of available time slots.');
        setLoading(false);
        return;
    }

    if (endTimeObj <= startTimeObj) {
        setTimeError('End time must be after the start time.');
        setLoading(false);
        return;
    }

    if (slotDuration < minimumSlotDuration) {
        setTimeError('Each slot must be at least 15 minutes long.');
        setLoading(false);
        return;
    }

    // Check for overlapping booked slots
    const overlappingBookedSlot = availableTimeSlots.find((slot) => {
        const slotStart = new Date(slot.start).getTime();
        const slotEnd = new Date(slot.end).getTime();
        return (
            startTimeObj.getTime() < slotEnd &&
            endTimeObj.getTime() > slotStart &&
            slot.isBooked &&
            slot.trackingId !== event.trackingId
        );
    });

    if (overlappingBookedSlot) {
        setTimeError('The selected time range overlaps with an already booked slot.');
        setLoading(false);
        return;
    }

    // Construct updated event object
    const updatedEvent = {
        ...event,
        clinicId: clinicId,
        title: event.title,
        subject,
        start: new Date(startTime),
        end: new Date(endTime),
        doctor: event.doctor,
        isBooked: true,
        status: 'BO',
        // intakeForm: {
        //     // medicalHistory,
        //     // currentMedications,
        //     // allergies,
        // },
    };

    try {
        // Step 1: Fetch CSRF Token
        const csrfToken = await fetchCsrfToken();
        if (!csrfToken) throw new Error("CSRF token not received.");

        // Step 2: Prepare API Request Data
        const apiUrl = FormatUrl('/create-slot/');
        const formData = new URLSearchParams();
        formData.append('clinic_id', clinicId);
        formData.append('patient_id', patientId);
        formData.append('slot_id', slotId);
        formData.append('practitioner_id', event.practitioner_id);
        // if (medicalHistory) formData.append('medical_history', medicalHistory);
        // if (currentMedications) formData.append('current_medications', currentMedications);
        // if (allergies) formData.append('allergies', allergies);

        // Step 3: Send API Request
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-CSRFToken': csrfToken,
            },
            credentials: 'include',
            body: formData,
        });

        // Handle API Response
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to save slot: ${errorText}`);
        }

        await response.json(); 

        // Step 4: Update Local Storage
        const updatedDetails = {
            ...savedDetails,
            selectedSlot: { ...event, status: 'BO', subject },
        };
        localStorage.setItem('patientBookingDetails', JSON.stringify(updatedDetails));

        notifySuccess(t("event_modal.slot_saved_successfully"));

        // Step 5: Update State
        onSave(updatedEvent, event);
        localStorage.setItem('slotCreationSuccess', 'true');

    } catch (error) {
        console.error('Error saving slot:', error);
        notifyError(t("event_modal.error_saving_slot"));
        setTimeError(t("event_modal.error_saving_slot"));
    } finally {
        setLoading(false);
    }
  };


  const fetchCsrfToken = async () => {
      try {
          const csrfApiUrl = FormatUrl("/csrf-token/");
          const response = await fetch(csrfApiUrl, {
              method: "GET",
              headers: { "Content-Type": "application/json" },
              credentials: "include",
          });

          if (!response.ok) throw new Error("Failed to fetch CSRF token");

          const csrfData = await response.json();
          return csrfData.csrfToken;
      } catch (error) {
          console.error("CSRF Token Fetch Error:", error);
          return null;
      }
  };


  const shouldShowSaveButton = (event) => {
    // Ensure the event is not already booked or completed
    const validStatuses = ['BO', 'AP', 'CA', 'CO']; // Backend statuses for booked, approved, canceled, and completed
  
    // Save button appears only if the event is not already saved or approved
    return !validStatuses.includes(event.status);
  };
  

  // const isIntakeFormReadOnly = event.status === 'BO' ||  event.status === 'AP' || event.status === 'CO';
  // console.log(isIntakeFormReadOnly, "isIntakeFormReadOnly")
  const isReadOnly =  event.status === 'AP' || event.status === 'CO'; 

  // Function to generate the PDF for the intake form
  // const handleDownloadPDF = () => {
  //   const doc = new jsPDF();
    
  //   // Title and Logo (optional)
  //   // doc.addImage('logo.png', 'PNG', 15, 5, 50, 20); 
  
  //   // Customizing the PDF appearance
  //   doc.setFont('helvetica', 'bold');
  //   doc.setFontSize(22);
  //   doc.text('Patient Appointment & Intake Form', 105, 20, { align: 'center' }); // Centered title
  //   doc.setFont('helvetica', 'normal');
  //   doc.setLineWidth(0.5);
  //   doc.line(15, 25, 195, 25); // Line separator
  
  //   // Adding appointment and patient info
  //   doc.setFontSize(12);
  //   doc.text(`Patient Name: ${event.patientName || 'N/A'}`, 20, 40);
  //   doc.text(`Subject: ${subject || 'N/A'}`, 20, 50);
  //   doc.text(`Start Time: ${startTime ? moment(startTime).format('MMMM Do YYYY, h:mm a') : 'N/A'}`, 20, 60);
  //   doc.text(`End Time: ${endTime ? moment(endTime).format('MMMM Do YYYY, h:mm a') : 'N/A'}`, 20, 70);
  //   doc.text(`Doctor: ${event.doctor || 'N/A'}`, 20, 80);
  
  //   // Adding intake form details with headers and box structure
  //   doc.setFont('helvetica', 'bold');
  //   doc.text('Medical History:', 20, 100);
  //   doc.setFont('helvetica', 'normal');
  //   doc.setTextColor(80, 80, 80); // Light grey text color for content
  //   doc.text(medicalHistory || 'N/A', 20, 110, { maxWidth: 170 }); // Text wrapping for long content
  
  //   // doc.setTextColor(0, 0, 0); 
  //   // doc.setFont('helvetica', 'bold');
  //   // doc.text('Current Medications:', 20, 130);
  //   // doc.setFont('helvetica', 'normal');
  //   // doc.setTextColor(80, 80, 80); 
  //   // doc.text(currentMedications || 'N/A', 20, 140, { maxWidth: 170 });
  
  //   // doc.setTextColor(0, 0, 0); 
  //   // doc.setFont('helvetica', 'bold');
  //   // doc.text('Allergies:', 20, 160);
  //   // doc.setFont('helvetica', 'normal');
  //   // doc.setTextColor(80, 80, 80); 
  //   // doc.text(allergies || 'N/A', 20, 170, { maxWidth: 170 });
  
  //   // Draw rectangles for visual separation
  //   doc.setDrawColor(150); // Light grey borders
  //   doc.setLineWidth(0.2);
  //   doc.rect(15, 90, 180, 30); // Medical History section
  //   doc.rect(15, 120, 180, 30); // Current Medications section
  //   doc.rect(15, 150, 180, 30); // Allergies section
  
  //   // Footer
  //   doc.setFontSize(10);
  //   doc.setTextColor(0, 0, 0); // Reset to black
  //   doc.text('Generated on: ' + moment().format('MMMM Do YYYY, h:mm a'), 20, 190);
  //   doc.setLineWidth(0.1);
  //   doc.line(15, 195, 195, 195); // Footer line separator
  
  //   // Save the document
  //   doc.save('patient_appointment_and_intake_form.pdf');
  // };
  

  // Function to fetch intake form data from API
  // const fetchIntakeForm = useCallback(async (appointmentId) => {
  //   try {
  //     if (!appointmentId) {
  //       console.error("Missing appointment ID");
  //       return;
  //     }

  //     // Fetch CSRF Token
  //     const csrfResponse = await fetch(FormatUrl("/csrf-token/"), {
  //       method: "GET",
  //       headers: { "Content-Type": "application/json" },
  //       credentials: "include",
  //     });
  //     const csrfData = await csrfResponse.json();
  //     const csrfToken = csrfData.csrfToken;

  //     // API call to get intake form details
  //     const apiUrl = FormatUrl("/get-ppointment-intake-form/");
  //     const formData = new URLSearchParams();
  //     formData.append("appointment_id", appointmentId);

  //     const response = await fetch(apiUrl, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/x-www-form-urlencoded",
  //         "X-CSRFToken": csrfToken,
  //       },
  //       credentials: "include",
  //       body: formData,
  //     });

  //     if (!response.ok) throw new Error("Failed to fetch intake form.");

  //     const data = await response.json();
  //     if (data.status === "failure") throw new Error(data.error || "Unknown error");

  //     console.log("Fetched Intake Form Data:", data);

  //     //Update state with fetched intake form data
  //     // setMedicalHistory(data.medical_history || "");
  //     // setCurrentMedications(data.current_medications || "");
  //     // setAllergies(data.allergies || "");
  //   } catch (error) {
  //     console.error("Error in fetchIntakeForm:", error.message);
  //     notifyError(t("event_modal.error_fetching_intake_form"));
  //   }
  // }, [t]);

  
  // useEffect(() => {
  //   if (event.status === "BO" || event.status === "AP" || event.status === "CO") {
  //     fetchIntakeForm(event.appointmentId);
  //   }
  // }, [event.appointmentId, event.status, fetchIntakeForm]);


  return (
    <div className="event-modal-overlay">
      {/* <div className="event-modal-content horizontal-layout"> */}
      <div className="event-modal-content single-column">
        <div className="appointment-section">
          <h3 style={{marginBottom:'2.5rem'}}>{t("event_modal.appointment_details")}</h3>
            <div className="form-group">
              <label>{t("event_modal.patient_name")}:</label>
              <input type="text" value={event.patientName || ''} readOnly />
            </div>

            <div className="form-group">
              <label>{t("event_modal.practitioner")}:</label>
              <input type="text" value={event.doctor} readOnly />
              {isFirstTimeEditing  && (
                <small>
                  {t("event_modal.change_practitioner")} 
                  <Link to={user?.patient_id ? `/scheduling/${user.patient_id}` : "/dashboard"}>
                    {t("event_modal.click_here")}
                  </Link> 
                  {t("event_modal.go_back_scheduling")}
                </small>
              )}
            </div>

            <div className="form-group">
              <label>{t("event_modal.subject")}:</label>
              <input
                type="text"
                value={subject}
                onChange={(e) => {
                  setSubject(e.target.value);
                  setSubjectError('');
                }}
                required
                readOnly={isReadOnly}
              />
              {subjectError && <small className="error-text">{subjectError}</small>}
            </div>

            <div className="form-group">
              <label>{t("event_modal.start_time")}:</label>
              <input
                type="datetime-local"
                value={startTime} 
                onChange={(e) => setStartTime(e.target.value)} 
                readOnly
              />
            </div>

            <div className="form-group">
              <label>{t("event_modal.end_time")}:</label>
              <input
                type="datetime-local"
                value={endTime} 
                onChange={(e) => setEndTime(e.target.value)} 
                readOnly
              />
            </div>

            {timeError && <small className="error-text">{timeError}</small>}

            <p className="unlock-hint">
              {t("event_modal.amount_to_be_paid_with_hst")} - {amount} CAD
            </p>
            <div className="modal-actions">
            {/* Check if the Save button should be displayed */}
            {shouldShowSaveButton(event) && (
              <button className="event-modal-btn custom-save-btn" 
                onClick={() => {
                  if (validateForm()) {
                    handleSave();
                  }
                }}
                disabled={loading} 
              >
                {/* {loading ? t("event_modal.processing") : t("event_modal.make_payment_and_save")} */}
                {loading ? "Processing.." : "Save"}
              </button>
              )}

              <button className="event-modal-btn custom-close-btn" onClick={onClose} >
              {t("event_modal.close")}
              </button>
          </div>
        </div>

      </div>

    </div>
  );
};

export default EventModal;
